// it should be synchronised with SevenSenders\AnalyticsCommonBundle\DoctrineType\Analytics\WidgetStatusEnum
export default {
  INSTALL_CODE: 'install-code',
  READY_TO_PUBLISH: 'ready-to-publish',
  LIVE: 'live',
  INACTIVE: 'inactive',
};
